import type { Media } from '../../flotiq-client/types/api-response';

import { IFlotiqPluginEvent } from './IFlotiqPluginEvent';

type MediaAfterUploadEventInit = {
  /** Media object created by the upload */
  media: Media;
};

/**
 * An event that is fired for every file uploaded successfully in the media
 * library or from a form. Failed uploads do not fire it.
 * No result is expected.
 *
 * @eventName "flotiq.media::after-upload"
 * @memberof FlotiqPlugins.Events
 */
export class MediaAfterUploadEvent extends IFlotiqPluginEvent {
  constructor(initData: MediaAfterUploadEventInit) {
    super(initData);
  }
}
